import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { CisProLookupDto } from '@models/cis-pro-lookup-dto.interface';
import { SampleManagerSearchRequest } from '@models/sample-manager-search-request.interface';
import { SampleManagerSearchPagedResult } from '@models/sample-manager-search-paged-result.interface';

@Injectable({
  providedIn: 'root',
})
export class SampleManagerService {
  private readonly apiService = inject(ApiService);

  /**
   * Feature B — look up a single material by barcode.
   * Returns 404 (error) when not found; the caller handles the HttpErrorResponse.
   */
  getByBarcode(barcode: string): Observable<CisProLookupDto> {
    return this.apiService.get(
      `materials/sample-manager?barcode=${encodeURIComponent(barcode)}`
    );
  }

  /**
   * Feature A — multi-criteria search returning raw SampleManager values.
   */
  search(request: SampleManagerSearchRequest): Observable<SampleManagerSearchPagedResult> {
    return this.apiService.post('materials/sample-manager/search', request);
  }
}
